/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export { NzTransitionPatchModule as ɵNzTransitionPatchModule } from './transition-patch.module';
export { NzTransitionPatchDirective as ɵNzTransitionPatchDirective } from './transition-patch.directive';
